import React from 'react';

type DepsEqualFnType<TDeps extends React.DependencyList> = (
  prevDeps: TDeps,
  nextDeps: TDeps,
) => boolean;

export const useCustomCompareEffect = <TDeps extends React.DependencyList>(
  effect: React.EffectCallback,
  deps: TDeps,
  depsEqual: DepsEqualFnType<TDeps>,
) => {
  const ref = React.useRef<TDeps | undefined>(undefined);

  if (!ref.current || !depsEqual(deps, ref.current)) {
    ref.current = deps;
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: it's correct, just bad biome
  React.useEffect(effect, ref.current);
};
